const PopUp = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const benefits = ['Affiliate Marketing', 'Gifting', 'Discount codes', 'Campaigns', 'Content creation', 'Additional opportunities'];
  return /*#__PURE__*/React.createElement("div", null, !isOpen && /*#__PURE__*/React.createElement("button", {
    className: "popUp",
    onClick: () => {
      setIsClosing(false);
      setIsOpen(true);
    }
  }, "Ambassador Program"), isOpen && /*#__PURE__*/React.createElement("div", {
    className: isClosing ? 'popupContainer FadeOut' : 'popupContainer FadeIn'
  }, /*#__PURE__*/React.createElement("button", {
    className: "popUpClose",
    onClick: () => {
      setIsClosing(true);
      setTimeout(() => setIsOpen(false), 500);
    }
  }, "\u2715"), /*#__PURE__*/React.createElement("img", {
    className: "popupLogo",
    width: "110px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/TLF-logo.png?v=1659988976",
    alt: "logo"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "popupTitle"
  }, "Let's Work Together!"), /*#__PURE__*/React.createElement("p", {
    className: "popupText"
  }, "As an ambassador/affiliate, you'll enjoy exclusive benefits such as early access to our latest releases, personalized discount codes for your followers, competitive commission, potential exposure across our digital platforms, and potential collaboration opportunities for future product development and events."), /*#__PURE__*/React.createElement("a", {
    href: "/pages/collab?utm_source=website&utm_medium=widget&utm_id=ambassador",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "popupButton"
  }, "Apply Now")), /*#__PURE__*/React.createElement("h1", {
    className: "benefitsTitle"
  }, "Collab Benefits"), benefits.map(benefit => /*#__PURE__*/React.createElement("div", {
    className: "benefitContainer",
    key: benefit
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    className: "benefitArrow"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
  })), /*#__PURE__*/React.createElement("p", {
    className: "benefitsList"
  }, benefit)))));
};
